import { render, staticRenderFns } from "./ImportTableBudget.vue?vue&type=template&id=90203884&"
import script from "./ImportTableBudget.vue?vue&type=script&lang=js&"
export * from "./ImportTableBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports